import React, { Component } from 'react';
import { connect } from '~/redux/connect';
import { getResetPasswordResult } from '~/stateGetter';
import { presentAuthError } from '~/statePresenter';
import { ForgotPasswordForm } from '~/ui/LoginForm';
import { AuthLayout } from './AuthLayout';
import { Link } from "~/ui/Link/Link";

export class ForgotPasswordPage extends Component {
    get success() {
        if (!this.props.success) return null;
        return {
            title: this.props.trans("forgotPasswordPage.successTitle"),
            message: this.props.trans("forgotPasswordPage.successMessage"),
        };
    }

    get hasError() {
        const error = this.props.error;
        return !(!error || !error.length)
    }
    
    get title() {
        let { trans } = this.props;
        if (this.hasError) return trans('forgotPasswordPage.errorTitle')
        return this.success?.title || trans('forgotPasswordPage.welcomeTitle')
    }

    get message() {
        let { trans, error } = this.props;
        if (this.hasError) return error;
        return this.success?.message || trans('forgotPasswordPage.welcomeMessage');
    }

    get labels() {
        return {
            username: this.props.trans("username"),
            submitButton: this.props.trans("forgotPasswordPage.submitButton"),
        }
    }

    renderFooter = (color) => {
        return <Link href="/" color={color} shouldPush>{this.props.trans("forgotPasswordPage.login")}</Link>
    }


    render() {
        return (
            <AuthLayout message={this.message} title={this.title} renderFooter={this.renderFooter}>
                <ForgotPasswordForm labels={this.labels} />
            </AuthLayout>
        );
    }
}

const RXForgotPasswordPage = connect(
    (state) => {
        const requestPasswordLinkResult = getResetPasswordResult(state, 'requestResetPasswordLink') ?? {}
        
        return {
            success: requestPasswordLinkResult.status === "successfull",
            error: requestPasswordLinkResult.status === "errored" && requestPasswordLinkResult.error,
        };
    },
)(ForgotPasswordPage);

export default RXForgotPasswordPage;
